import { BankingDepositDto } from './banking-deposit/banking-deposit.dto';
import { BaseDto } from './base.dto';
import { CardDataDto } from './cardData.dto';
import { CurrencyExchangeRateDto } from './currency-exchange-rate/currency-exchange-rate.dto';
import { FinanceHouseAccountDto } from './finance-house-account/finance-house-account.dto';
import { GiftCardDto } from './gift-card';
import { MerchantDto } from './merchant.dto';
import { MerchantPaymentMethodOptionDto } from './merchantPaymentMethodOption.dto';
import { PaymentMethodDto } from './paymentMethod.dto';
import { ServiceFeeDto } from './serviceFee.dto';

export class MerchantPaymentMethodDto extends BaseDto {
  merchant?: MerchantDto;
  merchantId?: number;
  paymentMethod: PaymentMethodDto;
  enabled: boolean;
  sequence: number;
  selected?: boolean;
  enableTenderedAmount: boolean;
  isDefaultOnExpressCheckout?: boolean;
  merchantPaymentMethodOptions?: MerchantPaymentMethodOptionDto[];
  enableSplitPayment: boolean;
  isCardIntegrated: boolean;
  enableMultiCurrency: boolean;
  isProcessingFeeExempt?: boolean;


  /**
   * Note:
   * These amounts are for the client side 'MerchantPaymentMethodDto' on POS
   * The user can select a tenderedAmount and the changeAmount is calulated. They are sent on the CartRequestDto.merchantPaymentMethod
   * to the /order/cart-to-order endpoint but are actually saved on the orderPayment entity/table.
   */
  tenderedAmount?: number; // UP-3077
  changeAmount?: number; // UP-3342
  tipsAmount?: number; // UP-11796
  cashbackAmount?: number // UP-11796
  additionalAmount?: number;

  /**
   * UP-3877
   * Split payment properties - client side
   */
  selectedOption?: MerchantPaymentMethodOptionDto;
  isPartialTender?: boolean;
  selectedGiftCard?: GiftCardDto;
  authorizedAmount?: number;
  hasOtherPayments?: boolean;
  currencyExchangeRate?: CurrencyExchangeRateDto;
  selectedHouseAccount?: FinanceHouseAccountDto;
  selectedBankingDeposit?: BankingDepositDto;
  serviceFee?: ServiceFeeDto;
  data?: CardDataDto;
  surfboardTransactionId?: string;
}
